// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"63117925","140":"ef0a2254","989":"f13bbb94"}[chunkId] + ".chunk.js";
};